import { useContext } from 'react'

import { UserContext, UserContextProps } from '@/contexts/user'
import i18n from '@/locale/i18n'
import { Country } from '@/types/country'
import { User } from '@/types/user'

interface UseUserProps {
  user: UserContextProps['user']
  updateUser: (user: UserContextProps['user']) => void
}

export const useUser = (): UseUserProps => {
  const { user, setUser } = useContext(UserContext)

  const updateUser = (updatedUser: UserContextProps['user']) => {
    const consultationType = new URLSearchParams(window.location.search).get('q')

    const language = localStorage.getItem('languageSelected') || new URLSearchParams(window.location.search).get('language') || undefined
    if (language && language !== i18n.language) i18n.changeLanguage(language)

    const country = new URLSearchParams(window.location.search).get('country') || undefined
    const countryObj = {
      code: country
    } as Country

    const userObj: User = {
      ...updatedUser,
      data: {
        ...updatedUser?.data,
        language: updatedUser?.data?.language || language,
        country: updatedUser?.data?.country || (country ? countryObj : undefined)
      }
    }

    if (!consultationType) return setUser(userObj)

    // Add the consultation type to the route conditions in order to be able to navigate to the custom step
    setUser({
      ...userObj,
      routeConditions: {
        ...userObj?.routeConditions,
        consultationType
      }
    })
  }

  return {
    user,
    updateUser
  }
}
